import { onHold } from 'Common/Utils/regexPatterns';

const scanOnHold = (appointments) => {
    const onHoldAppointments = appointments.filter(appointment => appointment.readyForApproval && onHold.test(appointment.readyForApproval));
    const rfaNoneOnHold = onHoldAppointments.length === 0;
    const rfaSomeOnHold = onHoldAppointments.length > 0 && onHoldAppointments.length < appointments.length;
    const rfaAllOnHold = onHoldAppointments.length > 0 && onHoldAppointments.length === appointments.length;
    return {
        rfaNoneOnHold,
        rfaSomeOnHold,
        rfaAllOnHold
    };
};

export default scanOnHold;